import { atom } from 'jotai'

export const isNavHiddenAtom = atom(false)
